import React from "react";
import { useState } from "react";
import Cookies from "universal-cookie";
import axios from 'axios';
import { useEffect } from "react";
import Banner from '../assets/viviendas.jpg';
import Logo from '../assets/logo san nicolas.svg';
import { useNavigate } from "react-router-dom";
import './home.css'
import { set } from "react-hook-form";
function Home () {
    const [Dni,setDni] = useState([])

    const navigate = useNavigate()
    const cookies = new Cookies();
    useEffect(() =>{
      cookies.remove('user')
      cookies.remove('dni')
    }, [])
    const handleChange = e => {
        setDni(e.target.value);
    
    }
    const handleSubmit = e => {
      e.preventDefault()
   
      axios.post('https://viviendas-api.herokuapp.com/login', {dni: Dni}).then((response) => {
     
        if (response.data == 0) {
          cookies.set('USER', 'newuser', {path:'/'})
          cookies.set('dni', Dni, {path:'/'})
          
          //cookies.set('user', {}, {path:'/'})
       //   console.log(cookies.get('user'))
    console.log(cookies.get('dni'))
         navigate('/nuevoinscripto')
        }
        else {
     
          cookies.set('USER', 'dbuser', {path:'/'})
          cookies.set('dni', Dni, {path:'/'})
          cookies.set('user', response.data, {path:'/'})
         
       
          // console.log(cookies.get('dni'))
        navigate('/nuevoinscripto')
        }
      })

     
     //   window.location.href="/nuevoinscripto"
    }
    return(
        <div className="container-fluid">
        <div className="row">
        
          <div className="login">
            
            <div className="login-form">
              <img
                src={Logo}
                alt="logo"
               style={{ width: '62%', height: '61,15px'}}
              />
                <p>INSCRIPCIÓN A VIVIENDAS</p>
              <form onSubmit={handleSubmit} style={{ width: '100%'}}>
              
                <div className="form-group">
                  <label>Ingresar DNI</label>
                  <input
                    type="text"
                    className='form-control'
                    placeholder="DNI"
                    onChange={handleChange}
                    name="dni"
                  />
                </div>
                <button type="submit" style={{ width: '100%'}}>Ingresar a la Inscripción</button>
              </form>
            </div>
            </div>
         
          <div className="imagen">
          <div className="col-sm-6 px-0 d-none d-sm-block">
            <img src={Banner} alt="login image" className="login-img" />
          </div>
          </div>
        </div>
      </div>
    )
}
export default Home;